export default [
  // City College
  {
    id: '2',
    progress: 0,
    triggerMode: 'SCHEDULER',
  },
  // Athabasca High School
  {
    id: '3',
    progress: 0,
    triggerMode: 'USER',
  },
  // Brazeau Elementary School
  {
    id: '4',
    progress: 30,
    triggerMode: 'USER',
    userProcessedCount: 3,
  },
  // Doyle Elementary School
  {
    id: '5',
    progress: 100,
    triggerMode: 'USER',
  },
  // Alaska Elementary School
  {
    id: '6',
    progress: 50,
    triggerMode: 'SCHEDULER',
  },
];
